import React, { useCallback, useEffect, useState } from "react"
import { Card, CardBody, FieldFeedbackLabel } from "../../../../../../_metronic/_partials/controls"
import { RadioButtonGroup, SelectInput, TextAreaInput } from "../../../../../../component"
import { stringFormatting } from "../../../../../helpers/TextHelper"
import { RowModule } from "../../../../../../component/atoms/RowModule/RowModule.jsx"
import { useFormikContext } from "formik"
import { useDispatch, useSelector } from "react-redux"
import {
  getAvailableMember,
  getAvailableMemberEdit
} from "../../../../../../redux/actions/FieldOfficerAction"
import { renderLabelRequired } from "../../../../../helpers/FormikHelper"
import { useTranslation } from "react-i18next"
import {
  getListBaseBySubRegional,
  getListRegionalAll,
  getListRegencyBySubRegional,
  getListSubRegionalByRole,
  getWarehouseAvailableListByType
} from "../../../../../../redux/actions/MasterDataAction.jsx"
import { loadUserLogin } from "../../../../../../config/index.jsx"
import { WAREHOUSE_TYPE_ENUM } from "../../../../../../constants/StringConstant.js"
import { MASTER } from "../../../../../../constants/InitTypeConstants.js"
import { Skeleton } from "@material-ui/lab"
import { ROLE_ENUM } from "../../../../../../constants/RoleConstants.js"

export const CreateEditForm = ({ isReadOnly, btnSubmit, btnCancel, id, isPreview }) => {
  const { values: formValues, setFieldValue, setFieldError, errors, touched } = useFormikContext()
  const [stateTeam, setStateTeam] = useState([])
  const dispatch = useDispatch()
  const { FieldOfficer, MasterData, General } = useSelector((state) => state)
  const { t } = useTranslation()
  const userLogin = loadUserLogin()

  const onChangeRegional = (value) => {
    setFieldValue("regionalId", value || "")
    setFieldValue("subRegionalId", "")
    setFieldValue("baseId", "")
    setFieldValue("regencyIds", [])
    setFieldValue("warehouseId", "")
  }

  const onChangeSubRegional = (value) => {
    setFieldValue("subRegionalId", value)
    setFieldValue("baseId", "")
    setFieldValue("regencyIds", [])
  }

  const handleAssignWarehouseChange = (value) => {
    setFieldValue("useAvaliableWarehouse", String(value))
    if (value === "false") {
      setFieldValue("warehouseId", "")
      setFieldError("warehouseId", undefined)
    } else if (value === "true") {
      setFieldError("warehouseId", undefined)
      dispatch(getWarehouseAvailableListByType(WAREHOUSE_TYPE_ENUM.MOBILE))
    }
  }

  const handleRegionalList = useCallback(() => {
    const dataRegional =
      MasterData?.listRegionalAll?.map((regional) => ({
        label: regional.name,
        value: regional.id
      })) || []

    // In edit mode
    if (id && userLogin.role !== ROLE_ENUM.SUPER_ADMIN) {
      // If detail has regional_id, show only that regional
      if (FieldOfficer?.detail?.regional_id) {
        return dataRegional.filter((item) => item.value === FieldOfficer?.detail?.regional_id)
      }
      // If user has regional_id, show only user's regional
      else if (userLogin?.regional_id) {
        return dataRegional.filter((item) => item.value === userLogin?.regional_id)
      }
      // Otherwise show all options
      else {
        return dataRegional
      }
    }
    // In create mode
    else {
      // If user has regional_id, show only user's regional
      if (userLogin?.regional_id) {
        return dataRegional.filter((item) => item.value === userLogin?.regional_id)
      }
      // Otherwise show all options
      else {
        return dataRegional
      }
    }
  }, [MasterData?.listRegionalAll, userLogin?.regional_id, FieldOfficer?.detail?.regional_id, id])

  useEffect(() => {
    dispatch(getListRegionalAll())
    dispatch(getWarehouseAvailableListByType(WAREHOUSE_TYPE_ENUM.MOBILE))
    if (id) {
      dispatch(getAvailableMemberEdit(id))
    } else {
      dispatch(getAvailableMember())
    }
  }, [])

  useEffect(() => {
    if (MasterData?.listRegionalAll) {
      if (FieldOfficer?.detail?.regional_id) {
        setFieldValue("regionalId", FieldOfficer?.detail?.regional_id)
      } else if (userLogin?.regional_id) {
        setFieldValue("regionalId", userLogin?.regional_id)
      }
    }
  }, [MasterData?.listRegionalAll, userLogin?.regional_id, FieldOfficer?.detail?.regional_id])

  useEffect(() => {
    if (formValues["regionalId"]) {
      dispatch(getListSubRegionalByRole(formValues["regionalId"], userLogin?.role))
    }
  }, [formValues["regionalId"]])

  useEffect(() => {
    if (
      (formValues["subRegionalId"] !== null && formValues["subRegionalId"] !== "") ||
      formValues["subRegionalId"]
    ) {
      dispatch(getListBaseBySubRegional(formValues["subRegionalId"]))
      dispatch(getListRegencyBySubRegional(formValues["subRegionalId"]))
    }
  }, [formValues["subRegionalId"]])

  useEffect(() => {
    let newStateTeam = stateTeam
    newStateTeam.map((item) => {
      if (
        item.value === formValues["member_list_1"] ||
        item.value === formValues["member_list_2"]
      ) {
        item.isDisabled = true
      } else {
        item.isDisabled = false
      }
    })
    setStateTeam(newStateTeam)
  }, [formValues, stateTeam])

  useEffect(() => {
    if (FieldOfficer.availableMember) {
      setStateTeam(
        FieldOfficer.availableMember.map((value) => ({
          label: value.name,
          value: value.id,
          isDisabled: false
        }))
      )
    }
  }, [FieldOfficer])

  if (isPreview) {
    return (
      <>
        <Card className="card-custom card-shadowless">
          <h4 className="card-label mx-8 mb-8">{t("label_preview")}</h4>
          <CardBody>
            <div className="d-flex justify-content-around mt-5 w-full">
              <div className="flex-1">
                <div className={"d-flex flex-column my-5"} style={{ gap: 5 }}>
                  <span className={"text-neutral-gray"}>{t("label_regional")}</span>
                  <span className={"font-size-lg"}>
                    {stringFormatting(
                      MasterData?.listRegionalAll?.find(
                        (item) => item.id === formValues["regionalId"]
                      )?.name
                    )}
                  </span>
                </div>
                <div className={"d-flex flex-column my-5"} style={{ gap: 5 }}>
                  <span className={"text-neutral-gray"}>{t("label_sub_regional")}</span>
                  <span className={"font-size-lg"}>
                    {stringFormatting(
                      MasterData?.listSubRegionalByRole?.find(
                        (item) => item.id === formValues["subRegionalId"]
                      )?.name
                    )}
                  </span>
                </div>
                <div className={"d-flex flex-column my-5"} style={{ gap: 5 }}>
                  <span className={"text-neutral-gray"}>{t("sub_header_base")}</span>
                  <span className={"font-size-lg"}>
                    {stringFormatting(
                      MasterData?.listBaseBySubRegional?.find(
                        (item) => item.id === formValues["baseId"]
                      )?.name
                    )}
                  </span>
                </div>
                {formValues["regencyIds"]?.length > 0 && (
                  <div className={"d-flex flex-column my-5"} style={{ gap: 5 }}>
                    <span className={"text-neutral-gray"}>{"Kota/Kabupaten"}</span>
                    <span className={"font-size-lg"}>
                      {MasterData?.listRegencyBySubRegional
                        ?.filter((r) => formValues["regencyIds"]?.includes(r.id))
                        ?.map((r) => r.name)
                        ?.join(", ") || "-"}
                    </span>
                  </div>
                )}
              </div>
              <div className="flex-1">
                <div className={"d-flex flex-column my-5"} style={{ gap: 5 }}>
                  <span className={"text-neutral-gray"}>{t("label_team_member")}</span>
                  <span className={"font-size-lg"}>
                    {stringFormatting(
                      FieldOfficer.availableMember?.find(
                        (item) => item.id === formValues?.member_list_1
                      )?.name
                    )}
                    {formValues?.member_list_2 !== "" || formValues?.member_list_2 !== undefined
                      ? ", " +
                        stringFormatting(
                          FieldOfficer.availableMember?.find(
                            (item) => item.id === formValues?.member_list_2
                          )?.name
                        )
                      : ""}
                  </span>
                </div>
                <div className={"d-flex flex-column my-5"} style={{ gap: 5 }}>
                  <span className={"text-neutral-gray"}>{t("label_description")}</span>
                  <span className={"font-size-lg"}>
                    {stringFormatting(formValues?.description)}
                  </span>
                </div>
              </div>
            </div>
            <div className="border-bottom" />
            <div className="d-flex justify-content-around mt-5 w-full">
              <div className="flex-1">
                <div className={"d-flex flex-column my-5"} style={{ gap: 5 }}>
                  <span className={"text-neutral-gray"}>{t("label_odoo_warehouse_mobile")}</span>
                  <span className={"font-size-lg"}>
                    {id
                      ? FieldOfficer?.detail?.warehouse_code
                        ? stringFormatting(FieldOfficer?.detail?.warehouse_code)
                        : formValues["useAvaliableWarehouse"] === "false"
                        ? t("label_create_new_odoo_warehouse")
                        : stringFormatting(
                            MasterData?.listWarehouseAvailable?.find(
                              (item) => item.id === formValues["warehouseId"]
                            )?.name
                          )
                      : formValues["useAvaliableWarehouse"] === "true"
                      ? stringFormatting(
                          MasterData?.listWarehouseAvailable?.find(
                            (item) => item.id === formValues["warehouseId"]
                          )?.name
                        )
                      : t("label_create_new_odoo_warehouse")}
                  </span>
                </div>
              </div>
            </div>
            <div className={"d-flex justify-content-end align-items-center"}>
              {btnCancel}
              {btnSubmit}
            </div>
          </CardBody>
        </Card>
      </>
    )
  }

  return (
    <>
      <Card className="card-custom card-shadowless">
        <CardBody>
          <h4 className="card-label mb-8">
            {stringFormatting(id ? "Edit" : t("button_add"))} {stringFormatting("Tim Drone")}
          </h4>
          <RowModule customColumnCss="mb-5 col-lg-12 col-sm-12 col-md-12">
            <SelectInput
              name="regionalId"
              required
              onChange={onChangeRegional}
              editable={
                id
                  ? userLogin.role === ROLE_ENUM.SUPER_ADMIN
                    ? true
                    : !(userLogin?.regional_id || FieldOfficer?.detail?.regional_id)
                  : !userLogin?.regional_id
              }
              label={t("label_regional")}
              placeholder={t("placeholder_select_regional_item")}
              value={formValues["regionalId"]}
              options={handleRegionalList()}
            />
          </RowModule>
          <RowModule customColumnCss="mb-5 col-lg-12 col-sm-12 col-md-12">
            <SelectInput
              name="subRegionalId"
              required
              onChange={onChangeSubRegional}
              editable={
                !!(formValues["regionalId"] && formValues["regionalId"] !== "") &&
                (id ? userLogin.role === ROLE_ENUM.SUPER_ADMIN ? true : !FieldOfficer?.detail?.sub_regional_id : true)
              }
              label={t("label_sub_regional")}
              placeholder={t("placeholder_select_subregional")}
              value={formValues["subRegionalId"]}
              options={MasterData?.listSubRegionalByRole?.map((subRegional) => ({
                label: subRegional.name,
                value: subRegional.id
              }))}
            />
          </RowModule>
          {/* for select base */}
          <RowModule customColumnCss="mb-5 col-lg-12 col-sm-12 col-md-12">
            <SelectInput
              name="baseId"
              required
              editable={!!(formValues["subRegionalId"] && formValues["subRegionalId"] !== "")}
              label={t("sub_header_base")}
              onChange={(value) => setFieldValue("baseId", value)}
              placeholder={t("choose_base")}
              value={formValues["baseId"]}
              options={MasterData?.listBaseBySubRegional?.map((base) => ({
                label: base.name,
                value: base.id
              }))}
            />
          </RowModule>
          <RowModule customColumnCss="mb-5 col-lg-12 col-sm-12 col-md-12">
            <SelectInput
              name="regencyIds"
              isMulti
              editable={!!(formValues["subRegionalId"] && formValues["subRegionalId"] !== "")}
              label={"Kota/Kabupaten"}
              placeholder={"Pilih Kota/Kabupaten"}
              value={formValues["regencyIds"]}
              onChange={(values) => setFieldValue("regencyIds", values || [])}
              options={MasterData?.listRegencyBySubRegional?.map((regency) => ({
                label: regency.name,
                value: regency.id
              }))}
            />
          </RowModule>
          <RowModule customColumnCss="mb-5 col-lg-12 col-sm-12 col-md-12">
            <SelectInput
              key={0}
              name="member_list_1"
              editable={!isReadOnly}
              label={renderLabelRequired(t("label_team_member"))}
              placeholder={t("placeholder_input_team_member")}
              options={stateTeam}
              withoutFeedback={false}
              clearNow={true}
              value={formValues["member_list_1"]}
            />
            <SelectInput
              key={1}
              name="member_list_2"
              editable={!isReadOnly}
              placeholder={t("placeholder_input_team_member")}
              options={stateTeam}
              withoutFeedback={false}
              clearNow={true}
              onChange={(value) => setFieldValue("member_list_2", value || "")}
              value={formValues["member_list_2"]}
            />
          </RowModule>
          <RowModule customColumnCss="mb-5 col-lg-12 col-sm-12 col-md-12">
            <TextAreaInput
              editable={isReadOnly}
              label={t("label_description")}
              name="description"
              placeholder={t("placeholder_input_description")}
              type={"text"}
            />
          </RowModule>
        </CardBody>
      </Card>
      <Card className="card-custom card-shadowless">
        <CardBody>
          <RowModule>
            <h4 className="card-label mb-8">{t("label_assign_team_to_odoo_mobile_warehouse")}</h4>
          </RowModule>
          <RowModule>
            <RadioButtonGroup
              required
              editable={
                !(
                  id &&
                  FieldOfficer?.detail?.warehouse_id !== null &&
                  FieldOfficer?.detail?.warehouse_id !== ""
                )
              }
              name="useAvaliableWarehouse"
              onClick={handleAssignWarehouseChange}
              value={"true"}
              withoutFeedback={true}
              checked={formValues?.useAvaliableWarehouse === "true"}
              label={t("label_existing_odoo_warehouse")}
              row
            />
            <RadioButtonGroup
              required
              editable={
                !(
                  id &&
                  FieldOfficer?.detail?.warehouse_id !== null &&
                  FieldOfficer?.detail?.warehouse_id !== ""
                )
              }
              name="useAvaliableWarehouse"
              onClick={handleAssignWarehouseChange}
              value={"false"}
              withoutFeedback={true}
              checked={formValues?.useAvaliableWarehouse === "false"}
              label={t("label_create_new_odoo_warehouse")}
              row
            />
          </RowModule>
          <FieldFeedbackLabel
            error={errors?.useAvaliableWarehouse}
            touched={touched.useAvaliableWarehouse}
            label={t("label_assign_base_to_odoo_warehouse")}
          />
          {formValues?.useAvaliableWarehouse === "true" &&
            (!(
              id &&
              FieldOfficer?.detail?.warehouse_id !== null &&
              FieldOfficer?.detail?.warehouse_id !== ""
            ) ? (
              General?.loading &&
              General?.actionInitType === MASTER.GET_WAREHOUSE_AVAILABLE_LIST_BY_TYPE ? (
                <Skeleton variant={"rect"} height={48} />
              ) : (
                <RowModule customColumnCss="mb-5 col-lg-12 col-sm-12 col-md-12">
                  <SelectInput
                    required
                    editable={!isReadOnly && !(id && FieldOfficer?.detail?.warehouse_id)}
                    label={t("label_select_mobile_warehouse_odoo")}
                    name="warehouseId"
                    placeholder={t("placeholder_select_mobile_warehouse_odoo")}
                    options={MasterData?.listWarehouseAvailable.map((item) => ({
                      value: item.id,
                      label: item.name
                    }))}
                    value={formValues?.warehouseId}
                  />
                </RowModule>
              )
            ) : (
              <span className="">
                {t("label_warehouse_mobile_odoo_code")} :{" "}
                <span className="font-weight-bolder">
                  {stringFormatting(FieldOfficer?.detail?.warehouse_code)}
                </span>
              </span>
            ))}
          <div className={"d-flex justify-content-end align-items-center"}>
            {btnCancel}
            {btnSubmit}
          </div>
        </CardBody>
      </Card>
    </>
  )
}
